<template>
  <div class="m-4">
    <h2 @click="test" class="">{{ isViewMode ? 'Visualizza Cavallo' : (isEditMode ? 'Modifica Cavallo' : 'Nuovo Cavallo') }}</h2>
    
    <div v-if="loading">Loading...</div>
    <div v-else-if="horseNotFound" class="alert alert-danger" role="alert" style="color: white">
      Non hai il permesso di visualizzare le informazioni di questo cavallo.
    </div>

    <div v-if="!horseNotFound">
      <div v-if="isEditMode">
      <div v-if="horseNotFound">
        <p>Horse not found. Please check the ID.</p>
      </div>
      <div v-else >

        <!-- Visualizza le informazioni del cavallo solo se siamo in modalità edit -->
        <div class="container-fluid">
          <div class="row">
            <div class="col-lg-12">
              <div class="row">

                <div class="col-xl-4 mb-xl-0 mb-4">
                  <div class="card bg-transparent shadow-xl">
                    <div
                        class="overflow-hidden position-relative border-radius-xl"
                        :style="{ backgroundImage:'url(' + require('@/assets/img/curved-images/curved14.jpg') + ')'}"
                    >
                      <span class="mask" :class="`bg-gradient-dark`"></span>
                      <div class="card-body position-relative z-index-1 p-3">

                          <div class="row">
                            <div class="col-auto">
                              <div class="d-flex px-2 py-1">
                                <soft-avatar
                                    :img="getImage(horse.horse_images)"
                                    size="xxl"
                                    border-radius="sm"
                                    class="m-3"
                                    alt="profile_image"
                                />
                              </div>
                            </div>
                            <div class="col-auto my-auto">
                              <div>
                                <h5 class="mb-1 text-white">{{ horse.name }}</h5>
                                <p class="text-white text-sm opacity-8 mb-0">{{ horse.nickname || 'No Nickname' }}</p>
                              </div>
                            </div>
                          </div>

                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-xl-8">
                  <div class="row">
                    <div class="col mb-4" v-if="Permissions.hasPermission(horse, [Permissions.PERMISSION_VACCINE, Permissions.PERMISSION_DIAGNOSIS, Permissions.PERMISSION_THERAPY, Permissions.PERMISSION_OTHER_TREATMENT])">

                      <div class="card h-100">
                        <div class="card-header pb-0 p-3">
                          <div class="row" style="width: 110% !important;">
                            <div class="col-6 d-flex align-items-center">
                              <h6 class="mb-0">SALUTE</h6>
                            </div>
                            <div class="col-6 text-end">
                              <soft-button color="success" size="sm" variant="outline" @click="this.$router.push({ name: 'HorseHealth', params: {  } });">Tutti</soft-button>
                            </div>
                          </div>
                        </div>
                        <div class="card-body p-3 pb-0 mb-0">
                          <ul class="list-group">
                            <li v-if="health_overview.length == 0" style="text-align: center;" class="list-group-item border-0 d-flex justify-content-between ps-0 mb-2 border-radius-lg">-- NO DATA --</li>
                            <li v-for="(o, index) in health_overview" :key="index" class="list-group-item border-0 d-flex justify-content-between ps-0 mb-2 border-radius-lg">
                              <div class="d-flex flex-column">
                                <h6 class="mb-1 text-dark text-sm">
                                  {{  o.title }}
                                </h6>
                                <span class="text-xs">{{ o.type }}</span>
                              </div>
                              <div class="d-flex align-items-center text-sm font-weight-bold">
                                {{  this.$moment(o.date).format('L') }}
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>

                    </div>
                    <div class="col mb-4" v-if="Permissions.hasPermission(horse, Permissions.PERMISSION_DIET)">

                      <div class="card h-100">
                        <div class="card-header pb-0 p-3">
                          <div class="row" style="width: 110% !important;">
                            <div class="col-6 d-flex align-items-center">
                              <h6 class="mb-0">NUTRIZIONE</h6>
                            </div>
                            <div class="col-6 text-end">
                              <soft-button  color="success" size="sm" variant="outline" @click="this.$router.push({ name: 'HorseDiets', params: { id } });">Tutti</soft-button>
                            </div>
                          </div>
                        </div>
                        <div class="card-body p-3 pb-0 mb-0">
                          <ul class="list-group">
                            <li v-if="diets.length == 0" style="text-align: center;" class="list-group-item border-0 d-flex justify-content-between ps-0 mb-2 border-radius-lg">-- NO DATA --</li>
                            <li v-for="(d, index) in diets" :key="index" class="list-group-item border-0 d-flex justify-content-between ps-0 mb-2 border-radius-lg">
                              <div class="d-flex flex-column">
                                <h6 class="mb-1 text-dark text-sm">
                                  {{  d.food.name }}
                                </h6>
                                <span class="text-xs">{{ d.number_of_times_a_day }} di volte al giorno</span>
                              </div>
                              <div class="d-flex align-items-center text-sm font-weight-bold">
                                {{ d.quantity + ' ' + d.measure_unity }}
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>

                    </div>
                    <div class="col mb-4" v-if="Permissions.hasPermission(horse, Permissions.PERMISSION_TRAINIGN)">

                      <div class="card h-100">
                        <div class="card-header pb-0 p-3">
                          <div class="row" style="width: 110% !important;">
                            <div class="col-6 d-flex align-items-center">
                              <h6 class="mb-0">ALLENAMENTI</h6>
                            </div>
                            <div class="col-6 text-end">
                              <soft-button color="success" size="sm" variant="outline" @click="this.$router.push({ name: 'HorseTrainings', params: { id } });">Tutti</soft-button>
                            </div>
                          </div>
                        </div>
                        <div class="card-body p-3 pb-0 mb-0">
                          <ul class="list-group">
                            <li v-if="trainings.length == 0" style="text-align: center;" class="list-group-item border-0 d-flex justify-content-between ps-0 mb-2 border-radius-lg">-- NO DATA --</li>
                            <li v-for="(t, index) in trainings" :key="index" class="list-group-item border-0 d-flex justify-content-between ps-0 mb-2 border-radius-lg">
                              <div class="d-flex flex-column">
                                <h6 class="mb-1 text-dark text-sm">
                                  {{  t.training.name }}
                                </h6>
                              </div>
                              <div class="d-flex align-items-center text-sm font-weight-bold">
                                {{ t.ranking }}
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>

        <div class="container-fluid" style="padding-top: 1em;" v-if="horse.is_owner">
          <div class="row">
            <div class="col-lg-12">
              <div class="mb-4 card">
                  <div class="pb-0 card-header">
                    <h6>Richieste di follow</h6>
                  </div>
                  <div class="px-0 pt-0 pb-2 card-body">
                    <div class="p-0 table-responsive">
                      <Vueform>
                        <table class="table mb-0 align-items-center">
                        <thead>
                          <tr>
                            <th class="text-center ps-2 text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                              Utente
                            </th>
                            <th class="text-center ps-2 text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                              Data
                            </th>
                            <th class="text-center ps-2 text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                              Permessi
                            </th>
                            <th class="text-center ps-2 text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                              Maneggio
                            </th>
                            <th class="text-center ps-2 text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                              Confermato?
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(request, index) in horse.followed_horses"
                            :key="index"
                          >
                            <td class="text-sm align-middle">
                              <p class="text-center mb-0 text-sm font-weight-bold">
                                {{ request.user?.first_name }} {{ request.user?.last_name }} ({{ request.user?.username }})
                              </p>
                            </td>
                            <td>
                              <div class="px-3 py-1 d-flex">
                                <div class="d-flex flex-column justify-content-center">
                                  <h6 class="mb-0 text-sm">{{ $moment(request.created).format('L') }}</h6>
                                </div>
                              </div>
                            </td>
                            <td>
                              <div class="text-center mb-0 text-sm font-weight-bold" style="display: flex; max-width: 400px; flex-wrap: wrap" >
                                <soft-badge color="success" class="m-1" v-for="(permission, index) in getPermissionLabels(request)" :key="index">{{ permission }}</soft-badge>
                                <font-awesome-icon :icon="faEdit" @click="showPermissionModal(request)" style="margin: 5px; padding: 5px; cursor: pointer" />
                              </div>
                            </td>
                            <td class="text-sm align-middle">
                              <p class="text-center mb-0 text-sm font-weight-bold">
                                {{ request.riding_stable?.name ?? '---' }}
                              </p>
                            </td>
                            <td class="align-middle text-center">
                              <div
                                class="text-center px-3 py-1 d-flex justify-content-center align-items-center"
                              >
                                <ToggleElement :disabled="loading" :id="request.id" :default="request.confirmed_following" @change="updateConfirm"></ToggleElement>
                              </div>
                            </td>
                          </tr>
                          <tr v-if="horse?.followed_horses?.length == 0">
                          <td style="text-align: center;" colspan="5">NESSUNA RICHIESTA DI FOLLOW</td>
                          </tr>
                        </tbody>
                      </table>
                      </Vueform>
                    </div>
                  </div>
                </div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <div v-else>
      <p>Compila il form per inserire un nuovo cavallo</p>
    </div>

    <div class="py-4 container-fluid" v-if="!isViewMode || Permissions.hasPermission(horse, Permissions.PERMISSION_HORSE_INFO)">
      <Vueform ref="form$" v-model="horse" :disabled="isViewMode" sync style="display: block;"  @submit.prevent="">
        <HiddenElement name="followed_horses" />
        <HiddenElement name="permissions" />
        <HiddenElement name="is_owner" />
        <HiddenElement name="is_admin" />
        <div class="mt-3 row">
          <!-- Sezione Dati Anagrafici -->
          <div class="mt-4 col-12 col-md-4 col-xl-4 mt-xl-0">
            <div class="card">
              <div class="p-3 pb-0 card-header">
                <h6 class="mb-0">Dati Anagrafici</h6>
              </div>
              <div class="p-4 px-md-4 card-body">
                  <HiddenElement name="id" />
                  <div class="mb-3">
                    <TextElement :disabled="isViewMode" name="name" label="Nome" rules="required|string|max:100" placeholder="Nome"></TextElement>
                  </div>
                  <div class="mb-3">
                    <TextElement :disabled="isViewMode" name="nickname" label="Nickname" rules="nullable|string|max:100" placeholder="Nickname"></TextElement>
                  </div>
                  <div class="mb-3">
                    <TextElement :disabled="isViewMode" name="microchip" label="Microchip" rules="required|string|max:100" placeholder="Microchip"></TextElement>
                  </div>
                  <div class="mb-3">
                    <DateElement :disabled="isViewMode" label="Data di Nascita" name="foaling_date" rules="required" />
                  </div>
                  <div class="mb-3" v-if="$store.getters.isAdmin">
                    <SelectElement :disabled="isViewMode" name="owner_id" :delay="500" label="Proprietario" rules="nullable" placeholder="Proprietario" :items="searchUser" :search="true"></SelectElement>
                  </div>
                  <div class="mb-3">
                    <TextElement :disabled="isViewMode" name="cost" label="Costo" rules="numeric|nullable" placeholder="Costo"></TextElement>
                  </div>
                  <div class="mb-3">
                    <ToggleElement :disabled="isViewMode" name="school" label="Scuola" placeholder="Scuola"></ToggleElement>
                  </div>
                  <div class="mb-3">
                    <SelectElement
                     :disabled="isViewMode"
                     :search="true"
                      name="breed_id"
                      :native="false"
                      label="Razza (Breed ID)"
                      rules="required"
                      placehoder="ID della Razza"
                      :items="breeds"
                    />
                  </div>
                  <div class="mb-3">
                    <SelectElement
                     :disabled="isViewMode"
                     :search="true"
                      name="colour_id"
                      :native="false"
                      label="Colore (Colour ID)"
                      rules="required"
                      placehoder="ID del Colore"
                      :items="colours"
                    />
                  </div>
                  <div class="mb-3">
                    <SelectElement
                     :disabled="isViewMode"
                      name="genre_id"
                      :native="false"
                      label="Genere"
                      rules="required"
                      :items="genres"
                    />
                  </div>

                  <div class="mb-3">
                    <SelectElement
                     :disabled="isViewMode"
                      name="sex"
                      :native="false"
                      label="Sesso"
                      rules="required"
                      :items="[
                        'M',
                        'F',
                      ]"
                    />
                  </div>
                  <div class="mb-3">
                    <TextElement :disabled="isViewMode" name="height" label="Altezza" rules="nullable|numeric" placeholder="Altezza"></TextElement>
                  </div>
                  <div class="mb-3">
                    <TextElement :disabled="isViewMode" name="father" label="Padre" rules="string|max:100|nullable" placeholder="Padre"></TextElement>
                  </div>
                  <div class="mb-3">
                    <TextElement :disabled="isViewMode" name="mother" label="Madre" rules="string|max:100|nullable" placeholder="Madre"></TextElement>
                  </div>
                  <div class="mb-3">
                    <TextElement :disabled="isViewMode" name="grandparent" label="Nonno" rules="string|max:100|nullable" placeholder="Nonno"></TextElement>
                  </div>
              </div>
            </div>
          </div>

          <!-- Sezione F.I.S.E., F.E.I. e A.P.A. -->
          <div class="mt-4 col-12 col-md-4 col-xl-4 mt-xl-0">
            <div class="card h-60">
              <div class="p-3 pb-0 card-header">
                <h6 class="mb-0">F.I.S.E.</h6>
              </div>
              <div class="p-4 card-body">
                  <div class="mb-3">
                    <TextElement :disabled="isViewMode" name="fise_passport" label="Passaporto F.I.S.E." rules="string|max:100|nullable" placeholder="Passaporto"></TextElement>
                  </div>
                  <div class="mb-3">
                    <DateElement :disabled="isViewMode" name="fise_passport_expiration" label="Data di Scadenza F.I.S.E." rules="" placeholder="Data di Scadenza" ></DateElement>
                  </div>
              </div>
            </div>

            <div class="mt-4 card h-60">
              <div class="p-3 pb-0 card-header">
                <h6 class="mb-0">F.E.I.</h6>
              </div>
              <div class="p-4 card-body">
                  <div class="mb-3">
                    <TextElement :disabled="isViewMode" name="fei_passport" label="Passaporto F.E.I." rules="string|max:100|nullable" placeholder="Passaporto"></TextElement>
                  </div>
                  <div class="mb-3">
                    <DateElement :disabled="isViewMode" name="fei_passport_expiration" label="Data di Scadenza F.E.I." rules="" placeholder="Data di Scadenza"></DateElement>
                  </div>
              </div>
            </div>

            <div class="mt-4 card h-60">
              <div class="p-3 pb-0 card-header">
                <h6 class="mb-0">A.P.A.</h6>
              </div>
              <div class="p-4 card-body">
                  <div class="mb-3">
                    <TextElement :disabled="isViewMode" name="apa_passport" label="Passaporto A.P.A." rules="string|max:100|nullable" placeholder="Passaporto"></TextElement>
                  </div>
                  <div class="mb-3">
                    <DateElement :disabled="isViewMode" name="apa_passport_expiration" label="Data di Scadenza A.P.A." rules="" placeholder="Data di Scadenza"></DateElement>
                  </div>
              </div>
            </div>
          </div>

          <!-- Sezione Posizione -->
          <div class="mt-4 col-12 col-md-4 col-xl-4 mt-xl-0">
            <div v-if="Permissions.hasPermission(horse, [Permissions.PERMISSION_WEIGHT])">
              <div class="card h-60 mb-4" v-if="isEditMode">
              <div class="card-header pb-0 p-3">
                <div class="row" style="width: 110% !important;">
                  <div class="col-6 d-flex align-items-center">
                    <h6 class="mb-0">Peso</h6>
                  </div>
                  <div class="col-6 text-end">
                    <soft-button :disabled="isViewMode" color="success" size="sm" variant="outline" @click="this.$router.push({ name: 'HorseWeights', params: { id: horse.id } });">Tutti</soft-button>
                  </div>
                </div>
              </div>
              <div class="card-body p-3 pb-0 mb-0">
                <ul class="list-group">
                  <li v-if="weights.length == 0" style="text-align: center;" class="list-group-item border-0 d-flex justify-content-between ps-0 mb-2 border-radius-lg">-- NO DATA --</li>
                  <li v-for="(w, index) in weights" :key="index" class="list-group-item border-0 d-flex justify-content-between ps-0 mb-2 border-radius-lg">
                    <div class="d-flex flex-column">
                      <h6 class="mb-1 text-dark text-sm">
                        {{  this.$moment(w.date).format('LL') }}
                      </h6>
                    </div>
                    <div class="d-flex align-items-center text-sm font-weight-bold">
                      {{ w.weight }} kg
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div class="card h-60 mb-4" v-else>
              <div class="p-3 pb-0 card-header">
                <div style="display: flex; justify-content: space-between; width: 100%">
                    <h5>Peso</h5>
                    <button type="button" id="add-timetable" class="btn btn-primary btn-sm" @click="weightModal = 1">+ Nuovo</button>
                  </div>
              </div>
              <div class="p-4 card-body">

                <div style="margin-bottom: 1em;border-bottom: 1px solid #eee; padding: 1em;">

                  <div v-for="(w, index) in weights" :key="index" style="display: flex; justify-content: space-between" >
                    <div><strong>{{ this.$moment(w.date).format('L') }}</strong> - {{ w.weight }} KG</div>
                    <font-awesome-icon @click="deleteWeight(index)" :icon="faTrash" color="red" />
                  </div>

                </div>

              </div>
            </div>
            </div>
            <div class="card h-60">
              <div class="p-3 pb-0 card-header">
                <h6 class="mb-0">Posizione</h6>
              </div>
              <div class="p-4 card-body">
                  <div class="mb-3">
                    <TextElement :disabled="isViewMode" name="boxNumber" label="Numero Box" rules="" placeholder="Numero Box"></TextElement>
                  </div>
                  <div class="mb-3">
                    <TextElement :disabled="isViewMode" name="structure" label="Struttura" rules="" placeholder="Struttura"></TextElement>
                  </div>
                  <div class="mb-3">
                    <DateElement :disabled="isViewMode" name="entryDate" label="Data Ingresso" rules="" placeholder="Data Ingresso"></DateElement>
                  </div>
                  <div class="mb-3">
                    <DateElement :disabled="isViewMode" name="exitDate" label="Data Uscita" rules="" placeholder="Data Uscita"></DateElement>
                  </div>
              </div>
            </div>
            <div class="mt-4 card h-60">
              <div class="p-3 pb-0 card-header">
                <h6 class="mb-0">Images</h6>
              </div>
              <div class="p-4 card-body">
                  <div class="mb-3">
                    <MultifileElement
                     :disabled="isViewMode"
                      name="horse_images"
                      :object="true"
                      :url="`${pathHorseImagesApi}`"
                      preview-url="https://equiup-api.13bit.dev/api/horse-images/get-thumbnail"
                      :upload-temp-endpoint="false"
                      label="Upload Image"
                      :fields="isViewMode ? {} : {
                        is_main: {type: 'toggle', label: 'Main?'}
                        }"
                      view="gallery"
                      :clickable="true"
                      :drop="true"
                      storeFile="url"
                      :soft-remove="true"
                    />
                  </div>
              </div>
            </div>
          </div>
        </div>
        <button type="button" v-if="isViewMode && (horse.is_owner || horse.is_admin)" class="btn btn-primary my-5"  @click="edit">Modifica</button>
        <button type="submit" v-if="!isViewMode" :class="{ loading: loading }" class="btn btn-primary my-5"  @click="save">Salva</button>
      </Vueform>
    </div>
    </div>

  </div>

<modal title="Add Weight" v-model="weightModal">
    <Vueform ref="weight$">
            <TextElement name="weight" label="Peso" rules="required|integer"></TextElement>
            <DateElement name="date" label="Data" rules="required"></DateElement>
            <button type="button" id="close" class="btn btn-secondary" @click="weightModal = 0">Chiudi</button>
            &nbsp;<button type="button" class="btn btn-primary"  @click="addWeight">Salva</button>
    </Vueform>
</modal>

<modal title="Edit Permissions" v-model="permissionModal">
    <Vueform ref="permissionForm$" v-model="selected_permissions" sync>
            <CheckboxgroupElement name="permissions" :items="Permissions.PERMISSION_LABELS" />
            <button type="button" id="close" class="btn btn-secondary" @click="permissionModal = 0">Chiudi</button>
            &nbsp;<button type="button" :class="{ loading: loading }" class="btn btn-primary"  @click="updatePermissions">Salva</button>
    </Vueform>
</modal>

</template>

<script>
import { horsesService } from '@/services/HorsesService';
import Permissions from '../../services/PermissionService';
import { horsesTrainingService } from '@/services/HorsesTrainingService';
import { horsesDietService } from '@/services/HorsesDietService';
import { horsesWeightService } from '@/services/HorsesWeightService';
import { coloursService } from '@/services/ColoursService';
import { genresService } from '@/services/GenresService';
import { breedsService } from '@/services/BreedsService';
import SoftAvatar from "@/components/SoftAvatar.vue";
import SoftBadge from "@/components/SoftBadge.vue";
import {horseImagesService} from "@/services/HorseImagesService";
import { useToast } from "vue-toastification";
import SoftButton from "@/components/SoftButton.vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faTrash, faEdit } from "@fortawesome/free-solid-svg-icons";
import Modal from "@/components/Modal";
const toast = useToast();

export default {
  name: 'horse',
  components: {SoftButton, SoftAvatar, FontAwesomeIcon, Modal, SoftBadge },
  props: {
    id: {
      type: [String, Number],
      required: false,
    },
    action: {
      type: [String, Number],
      required: false,
    },
  },
  data() {
    return {
      loading: false,
      Permissions,
      selected_request: null,
      selected_permissions: {permissions: ['']},
      faTrash, faEdit,
      breeds: [],
      genres: [],
      colours: [],
      weights: [],
      users: [],
      trainings: [],
      health_overview: [],
      diets: [],
      weightModal: 0,
      permissionModal: 0,
      user: null,
      horse: {
        name: '',
        nickname: '',
        microchip: '',
        foaling_date: '',
        breed_id: '',
        colour_id: '',
        sex: '',
        height: '',
        father: '',
        mother: '',
        grandparent: '',
        fise_passport: '',
        fise_passport_expiration: '',
        fei_passport: '',
        fei_passport_expiration: '',
        apa_passport: '',
        apa_passport_expiration: '',
        horse_images: [],
        boxNumber: '',
        structure: '',
        entryDate: '',
        exitDate: '',
        owner_id: null,
        followed_horses: [],
      },
      horseNotFound: false,
    };
  },
  computed: {
    pathHorseImagesApi() {
      return horseImagesService.getPath();
    },
    isEditMode() {
      return !!this.id;
    },
    isViewMode() {
      return this.action == 'view';
    },
  },
  created() {
    this.$store.dispatch('updateBreadcrumbs', [
      { title: 'Lista Cavalli', name: this.$store.getters.horseListMenuLink }
    ]);
  },
  mounted() {
    if (this.isEditMode) {
      this.fetchHorseData();
    }
    breedsService.getBreeds().then(breeds => {
      this.breeds = breeds.map(b => ({value: b.id, label: b.name}));
    });
    genresService.getGenres().then(genres => {
      this.genres = genres.map(g => ({value: g.id, label: g.name}));
    });
    coloursService.getColours().then(colours => {
      this.colours = colours.map(c => ({value: c.id, label: c.name}));
    });

    if(this.id){
      horsesWeightService.getHorseWeights(1, '', {horse_id: this.id}).then((data) => {
        this.weights = data.data.slice(0, 3);
      });
      horsesTrainingService.getHorseTrainings(1, '', {horse_id: this.id, status: 'inprogress'}).then((data) => {
        this.trainings = data.data.slice(0, 3);
      });
      horsesDietService.getHorseDiets(1, '', {horse_id: this.id, status: 'inprogress'}).then((data) => {
        this.diets = data.data.slice(0, 3);
      });
      horsesService.getHealthOverview(this.id).then((data) => {
        this.health_overview = data;
      });
    }

    document.addEventListener('click', (e) => {
      if(e.target.classList.contains('vf-toggle') || e.target.classList.contains('vf-toggle-handle') || e.target.classList.contains('vf-toggle-label')) this.mainToggleChanged(e);
    });

  },
  watch: {
    horse(){
      if(this.$store.getters.isAdmin && this.$refs.form$ && this.horse.user){
        this.$refs.form$.elements$.owner_id.updateItems(true).then(() =>  {
          this.$refs.form$.elements$.owner_id.update(this.horse.user.id.toString())
        });
      }
    }
  },
  methods: {
    async fetchHorseData(_id) {
      this.loading = true;
      this.horseNotFound = false;
      try {
        const horse = await horsesService.getHorseById(this.id ?? _id);
        if (!horse) {
          this.horseNotFound = true;
        } else {
          this.horse = horse;
          this.user = null;
          if(horse.owned_horses && horse.owned_horses.length > 0){
            horse.user = horse.owned_horses[0].user;
          }
        }
      } catch (error) {
        console.error('Error fetching horse data:', error);
        this.horseNotFound = true;
      } finally {
        this.loading = false;
      }
    },

    async searchUser(query){
      this.loading = true;
      const users = await horsesService.getUsers(query);
      this.loading = false;
      this.users = users.map(u => ({value: u.id, label: u.username + ' - ' + (u.email ?? 'NO EMAIL')}));
      if(this.user){
        this.users = [...this.users, {value: this.user.id, label: this.user?.username + ' - ' + (this.user?.email ?? 'NO EMAIL')}];
      }
      return this.users;
    },

    async removeUploadedImage(image_id){
      this.loading=true;
      await horsesService.deleteImage(image_id);
      this.loading=false;
      this.horse.horse_images = this.horse.horse_images.filter(image => image.id != image_id);
      toast(this.$t('Deleted'));
    },

    addWeight(){
      const form = this.$refs.weight$;
      form.validate();
      if (form.hasErrors) return;
      this.weights.push({weight: form.data.weight, date: form.data.date});
      this.weightModal = 0;
    },

    deleteWeight(index){
      this.weights.splice(index, 1);
    },

    edit(){
      this.$router.push({ name: 'Horse', params: { id: this.id } });
    },

    async save(){
      const form = this.$refs.form$;
      await form.validate();
      delete form.data.id;
      // remove all null fields
      for (const key in form.data) {
        if (form.data[key] === 'null' || form.data[key] === null) {
            delete form.data[key];
        }
      }
      if(!this.isEditMode){
        form.data['weights'] = this.weights;
      }
      if (!form.hasErrors) {
        this.loading=true;
        if(this.horse.id) form.data.id = this.horse.id;
        try{
          const _horse = await horsesService.save(form.data);

          toast(this.$t('operation_saved'));
          if(!this.isEditMode) {
            this.$router.push({ name: 'Horse', params: { id: _horse.id }, force: true });
            this.fetchHorseData(_horse.id);
          }
        }finally{
          this.loading=false;
        }
        
      }
    },
    
    getImage(horseImages) {
      return horseImagesService.getImage(horseImages);
    },
    mainToggleChanged(e){

      const toggle = e.target.closest('.vf-toggle');
      const container = e.target.closest('.vf-toggle-container');

      const index = container.attributes['aria-labelledby'].nodeValue.match(/\.(\d+)\./)[1];
      const newValue = toggle.classList.contains('vf-toggle-on');

      if (newValue == true) {
        this.horse.horse_images.forEach(item => item.is_main = false);
        this.horse.horse_images[index].is_main = true;
      }
    },
    getPermissionLabels(obj) {
      return Object.keys(Permissions.PERMISSION_LABELS)
          .filter(key => obj[key])
          .map(key => Permissions.PERMISSION_LABELS[key]);
    },
    getPermissions(obj) {
      return Object.keys(Permissions.PERMISSION_LABELS)
          .filter(key => obj[key]);
    },
    getPermissionLabel(key){
      return Permissions.PERMISSION_LABELS[key] ?? '---';
    },
    showPermissionModal(request){
      this.permissionModal = 1;
      this.selected_request = request;
      this.selected_permissions = {permissions: this.getPermissions(request)}
    },
    async updatePermissions(){
      const permissions = this.$refs.permissionForm$.data.permissions;
      const data = {
        id: this.selected_request.id,
      };
      // write a for to iterate through permissionLabels and select keys exist in permissions
      for(let permission of Object.keys(Permissions.PERMISSION_LABELS)){
          data[permission] = permissions.indexOf(permission) > -1 ? 1 : 0;
      }
      
      // for this example, I'm simulating the service call with a delay
      this.loading = true;
      await horsesService.updateFollowRequest(data).then(() => {
        toast(this.$t('Permissions_updated'));
        this.permissionModal = 0;
        this.fetchHorseData();
      }).finally(() => {
        this.loading = false;
      });
    },
    async updateConfirm(newValue, oldValue, element){
      const data = {
        id: element.id,
        confirmed_following: newValue ? 1 : 0,
      };
      const permissions = this.getPermissions(this.horse.followed_horses.find(follow => follow.id == element.id));
      for(let permission of Object.keys(Permissions.PERMISSION_LABELS)){
          data[permission] = permissions.indexOf(permission) > -1 ? 1 : 0;
      }
      this.loading = true;
      await horsesService.updateFollowRequest(data).then(() => {
        toast(this.$t('confirmed_following'));
        this.permissionModal = 0;
      }).finally(() => {
        this.loading = false;
      });
    }
  },
};
</script>

<style>
.vf-row{
  display: block !important;
}
</style>
